<template>
  <FormSubmitPopup
    :title="$t('exportClientExpenseDetail')"
    :value="show"
    :rightMethod="exportExpenseDetails"
    :disabledClose="loading"
    :leftMethod="() => show = false"
    :rightButtonText="$t('export')"
    small
  >
    <template v-slot:input>
      <v-container py-0 fluid>
        <v-layout>
          <v-flex>
            <DatePicker
              label="date"
              range
              v-model="dates"
              mode="date"
            />
          </v-flex>
        </v-layout>
      </v-container>
    </template>
  </FormSubmitPopup>
</template>

<script>
import DatePicker from './DatePicker'
import FormSubmitPopup from './FormSubmitPopup'
import { toMoney } from '../utils/tools'

export default {
  name: 'ExportClientsRechargeTransactionPopup',
  components: {
    FormSubmitPopup,
    DatePicker
  },
  props: {
    value: {
      required: true,
      type: Boolean
    },
    exportTableData: {
      type: Function,
      default: () => {
        return () => {}
      }
    }
  },
  data () {
    return {
      loading: false,
      dates: [new Date(), new Date()]
    }
  },
  computed: {
    show: {
      get: function () {
        return this.value
      },
      set: function (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    async exportExpenseDetails () {
      const [startDate, endDate] = this.dates
      if (!startDate || !endDate) return
      const data = await this.getCurDailyStatisticsData(startDate, endDate)
      const startDay = startDate.toISOString().slice(0, 10)
      const endDay = endDate.toISOString().slice(0, 10)
      this.exportTableData(data, `${startDay} ~ ${endDay}`)
    },
    async getCurDailyStatisticsData (startDate, endDate) {
      const statistics = await this.$store.dispatch('getDailyStatistics', {
        startDate,
        endDate
      })
      const data = statistics.reduce((res, item) => {
        const { clientKey, details } = item
        const targetStatistics = details.reduce((res, detail) => {
          const { statistics, type } = detail
          const { expense } = statistics
          if (type.includes('balance-deposit') || type.includes('balance-adjust')) return res
          const operate = type.includes('cancel') || type.includes('adjust-fee') ? -1 : 1
          res = (res || 0) + expense * operate
          return res
        }, 0)
        res[clientKey] = toMoney(targetStatistics)
        return res
      }, {})
      return data
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ExportClientExpenseDetailsPopup.vue